export default function Bar(){

    return (
        <div className="w-3/4 h-px bg-black my-20"></div>
    );

}